import React, { useContext, useEffect, useState } from 'react';
import { ArchiveModal, RegulationsModal, ScriptItems } from '../components/modules/ScriptPage';
import { BackButton, Button, CreateButton } from '../components/ui/Buttons';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { Roles, RouteNames, Status, projectTabs } from '../constants';
import { useGetProjectQuery, useGetScriptsQuery } from '../store/api';
import { Loading } from '../components/ui/Loading';
import { SearchContext } from '../context/Search/SearchContext';
import { RoleBasedComponent } from '../components/roles';
import { Tabs } from '../components/ui/Tabs';
import { CRMInput } from '../components/modules/ProjectsPage';

const Scripts: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const project_id = Number(new URLSearchParams(location.search).get('project_id'));
  const { data: project } = useGetProjectQuery(project_id);
  const { data: scripts, isLoading: isLoadingOnScripts } = useGetScriptsQuery(project_id);
  const { searchQuery } = useContext(SearchContext);
  const scripts_with_search = scripts?.data.scripts.filter(
    (script) =>
      script.name.toLowerCase().includes(searchQuery.toLowerCase().trim()) ||
      script.articul?.toLowerCase().includes(searchQuery.toLowerCase().trim()) ||
      script.internal_id.toLowerCase().includes(searchQuery.toLowerCase().trim())
  );
  const archivedScripts = scripts?.data.scripts.filter((item) => item.status === Status.ARCHIVED);
  const [regulationModal, setRegulationModal] = useState(false);
  const [archiveModal, setArchiveModal] = useState(false);

  const handleCreateScript = () => {
    navigate(RouteNames.SCRIPT + `/create?project_id=${project_id}`);
  };

  const handleOpenRegulationModal = () => {
    setRegulationModal(true);
  };

  const handleCloseRegulationModal = () => {
    setRegulationModal(false);
  };

  const handleOpenArchiveModal = () => {
    setArchiveModal(true);
  };

  const handleCloseArchiveModal = () => {
    setArchiveModal(false);
  };

  const tabs = projectTabs(t, project_id);

  useEffect(() => {
    !archivedScripts?.length && handleCloseArchiveModal();
  }, [archivedScripts]);

  return (
    <div className="scripts page-section" id="scripts">
      <div className="container">
        <div className="scripts__inner">
          <BackButton backUrl={'/projects'}>{project?.data.name}</BackButton>
          <Button onClick={handleOpenRegulationModal} className="regulations-btn" red>
            {t('projectsPage.regulations')}
          </Button>
          <div className="crm-input">
            {project && <CRMInput project_id={project?.data.id} url={project?.data.crm_url} />}
          </div>
          <Tabs tabs={tabs} defaultTab={0} />
          <RoleBasedComponent roles={[Roles.ADMIN, Roles.SUPERADMIN]}>
            <CreateButton onClick={handleCreateScript}>
              {t('scriptsPage.createScript')}
            </CreateButton>
          </RoleBasedComponent>
          {!!scripts_with_search?.length && <ScriptItems scripts={scripts_with_search} />}
          {!!archivedScripts?.length && (
            <div className="archive-btn">
              <Button onClick={handleOpenArchiveModal} outlined>
                {t('archive')}
              </Button>
            </div>
          )}
          {!scripts_with_search?.length && searchQuery && (
            <p className="empty">{t('nothingFound')}</p>
          )}
          {!scripts?.data.scripts.length && !isLoadingOnScripts && !searchQuery && (
            <RoleBasedComponent roles={[Roles.ADMIN, Roles.SUPERADMIN]}>
              <p className="empty">{t('scriptsPage.createFirstScript')}</p>
            </RoleBasedComponent>
          )}
          {isLoadingOnScripts && <Loading />}
        </div>
      </div>
      {!!archivedScripts?.length && (
        <ArchiveModal
          open={archiveModal}
          onClose={handleCloseArchiveModal}
          scripts={archivedScripts}
        />
      )}
      <RegulationsModal
        project_id={project_id}
        open={regulationModal}
        onClose={handleCloseRegulationModal}
      />
    </div>
  );
};

export default Scripts;
